import classes from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={classes["footer-wrapper"]}>
      <div className={classes.banner}>
        <div className={classes["banner-text"]}>
          Andrew Tanaka {"\u00A9"} {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
};

export default Footer;
